const MEDIA_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20stylized%20warm%20tone%20illustration%20of%20people%20reading%20manga%20comics%20on%20mobile%20phone%20in%20cozy%20cafe%2C%20soft%20natural%20lighting%2C%20Japanese%20comic%20style%20decor%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20editorial%20photography%2C%20clean%20aesthetic&width=600&height=400&seq=media-card-01&orientation=landscape',
    title: '漫友线下聚会精彩回顾',
    tag: '社区活动',
    date: '2026.07.20',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20art%20exhibition%20display%20with%20framed%20comic%20panels%20on%20cream%20walls%2C%20warm%20gallery%20lighting%2C%20visitors%20admiring%20artwork%2C%20Japanese%20manga%20style%2C%20soft%20warm%20tones%2C%20elegant%20and%20artistic%20atmosphere&width=600&height=400&seq=media-card-02&orientation=landscape',
    title: '国漫原画展全国巡展中',
    tag: '线下展览',
    date: '2026.07.15',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Creative%20process%20of%20manga%20artist%20sketching%20comic%20pages%20with%20drawing%20tablet%20and%20traditional%20tools%2C%20warm%20studio%20lighting%2C%20sketches%20on%20desk%2C%20artistic%20workspace%2C%20cozy%20atmosphere%2C%20warm%20amber%20and%20neutral%20tones&width=600&height=400&seq=media-card-03&orientation=landscape',
    title: '知名漫画家创作幕后揭秘',
    tag: '独家专访',
    date: '2026.07.10',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Manga%20fan%20community%20discussion%20event%20with%20people%20sharing%20comic%20books%2C%20warm%20indoor%20setting%2C%20bookshelves%20filled%20with%20manga%20volumes%2C%20friendly%20atmosphere%2C%20soft%20lighting%2C%20warm%20cream%20and%20coral%20color%20scheme&width=600&height=400&seq=media-card-04&orientation=landscape',
    title: '新新漫画读者见面会花絮',
    tag: '读者互动',
    date: '2026.07.05',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          漫友社区
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          不止看漫画，一起参与漫友圈的精彩活动
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative overflow-hidden h-[200px]">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-[11px] font-bold text-foreground-700">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center cursor-pointer">
                  <i className="ri-play-circle-fill text-primary-500 text-xl"></i>
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-[14px] font-bold text-foreground-800 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-[12px] text-foreground-400">{item.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}